// extracted by mini-css-extract-plugin
module.exports = {"day-group":"SupplierSchedule_day-group__1K-Pm","day-name":"SupplierSchedule_day-name__2YC-Q"};